import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["text", "accessibilityLabel"],
  _excluded2 = ["text", "type"],
  _excluded3 = ["newWindow", "url"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useRef } from 'react';
import classnames from 'classnames';
import { useShowHidePricingFormWithZip } from "../../Utility/Hooks";
import { RecommendedFlag } from "../../Flag/RecommendedFlag/RecommendedFlag";
import { Link } from "../../Button/Link/Link";
import { MatchHeightElement } from "../../Utility/MatchHeight/MatchHeightElement";
import { Image } from "../../Image/Image/Image";
import { Text } from "../../Text/Text/Text";
import { Button } from "../../Button/Button/Button";
import { PricingForm } from "../../Price/PricingForm/PricingForm";
import { Popup } from "../../Popup/Popup/Popup";
import { PopupContentBlock } from "../../Block/PopupContentBlock/PopupContentBlock";
import styles from "./SmallProductSquare.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var smallProductSquareSubheadTypog = ['bodycopy', 'bodycopySmall'];
export var SmallProductSquare = function SmallProductSquare(_ref) {
  var _ref$flag = _ref.flag,
    flag = _ref$flag === void 0 ? '' : _ref$flag,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? '' : _ref$eyebrow,
    headline = _ref.headline,
    _ref$subhead = _ref.subhead,
    subhead = _ref$subhead === void 0 ? '' : _ref$subhead,
    _ref$subheadTypog = _ref.subheadTypog,
    subheadTypog = _ref$subheadTypog === void 0 ? 'bodycopy' : _ref$subheadTypog,
    subheadingPrice = _ref.subheadingPrice,
    icon = _ref.icon,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {} : _ref$cta,
    _ref$ctaTwo = _ref.ctaTwo,
    ctaTwo = _ref$ctaTwo === void 0 ? {} : _ref$ctaTwo,
    _ref$footnote = _ref.footnote,
    footnote = _ref$footnote === void 0 ? '' : _ref$footnote,
    errorMessage = _ref.errorMessage,
    pricing = _ref.pricing,
    _ref$showPricingForm = _ref.showPricingForm,
    showPricingFormInit = _ref$showPricingForm === void 0 ? false : _ref$showPricingForm,
    _ref$hasPopup = _ref.hasPopup,
    hasPopup = _ref$hasPopup === void 0 ? false : _ref$hasPopup,
    _ref$popupContent = _ref.popupContent,
    popupContent = _ref$popupContent === void 0 ? {} : _ref$popupContent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    setCtaTwoHover = _useState2[1];
  var _useShowHidePricingFo = useShowHidePricingFormWithZip(showPricingFormInit),
    autoFocus = _useShowHidePricingFo.autoFocus,
    showPricingForm = _useShowHidePricingFo.showPricingForm,
    onZipClick = _useShowHidePricingFo.onZipClick;
  var popupRef = useRef(null);
  var showSubheadingPrice = subheadingPrice && subheadingPrice !== '';
  var hasCtaTwo = (ctaTwo === null || ctaTwo === void 0 ? void 0 : ctaTwo.text) && (ctaTwo === null || ctaTwo === void 0 ? void 0 : ctaTwo.url) && !hasPopup;
  var ctaTwoPopup = (ctaTwo === null || ctaTwo === void 0 ? void 0 : ctaTwo.text) && hasPopup;
  var renderLink = function renderLink(cta) {
    var text = cta.text,
      accessibilityLabel = cta.accessibilityLabel,
      otherProps = _objectWithoutProperties(cta, _excluded);
    var tabIndex = text ? -1 : 0;
    return /*#__PURE__*/_jsx(Link, _objectSpread({
      "aria-hidden": true,
      accessibilityLabel: accessibilityLabel ? accessibilityLabel : text,
      className: styles.backgroundLink,
      tabIndex: tabIndex
    }, otherProps));
  };
  var renderButton = function renderButton(cta) {
    var isCtaTwo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var text = cta.text,
      type = cta.type,
      otherProps = _objectWithoutProperties(cta, _excluded2);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      className: isCtaTwo ? styles.ctaTwo : type === 'link' ? styles.price : type === 'primary' ? styles.primaryButton : styles.secondaryButton,
      type: type,
      onHover: isCtaTwo ? function (e) {
        return setCtaTwoHover(e);
      } : function () {}
    }, otherProps), {}, {
      children: text
    }));
  };
  var togglePopup = function togglePopup() {
    var _popupRef$current;
    popupRef === null || popupRef === void 0 ? void 0 : (_popupRef$current = popupRef.current) === null || _popupRef$current === void 0 ? void 0 : _popupRef$current.togglePopup();
  };
  var renderPopupButton = function renderPopupButton(ctaTwo) {
    var newWindow = ctaTwo.newWindow,
      url = ctaTwo.url,
      otherProps = _objectWithoutProperties(ctaTwo, _excluded3);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      className: classnames(styles.ctaTwo, styles.ctaTwoPopup),
      type: ctaTwo.type,
      onClick: togglePopup,
      "aria-haspopup": true,
      onHover: function onHover(e) {
        return setCtaTwoHover(e);
      }
    }, otherProps), {}, {
      children: ctaTwo.text
    }));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [flag ? /*#__PURE__*/_jsxs("div", {
      className: styles.flag,
      children: [(cta === null || cta === void 0 ? void 0 : cta.url) && renderLink(cta), /*#__PURE__*/_jsx(RecommendedFlag, {
        text: flag
      })]
    }) : /*#__PURE__*/_jsx(MatchHeightElement, {
      group: "flag",
      children: /*#__PURE__*/_jsx("span", {})
    }), /*#__PURE__*/_jsx("div", {
      className: classnames({
        [styles.productSquare]: true,
        [styles["hasFlag"]]: flag
      }),
      children: /*#__PURE__*/_jsxs(MatchHeightElement, {
        group: "small_product_square",
        children: [(cta === null || cta === void 0 ? void 0 : cta.url) && renderLink(cta), /*#__PURE__*/_jsxs("div", {
          className: styles.productSquareTop,
          children: [(icon === null || icon === void 0 ? void 0 : icon.image1x) && /*#__PURE__*/_jsx("div", {
            className: styles.iconWrapper,
            children: /*#__PURE__*/_jsx(Image, {
              alt: icon.alt,
              src: icon.image1x,
              width: icon.width || undefined,
              height: icon.height || undefined,
              loading: icon.loading || 'lazy'
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [eyebrow && /*#__PURE__*/_jsx(Text, {
              typog: "eyebrow3",
              className: styles.eyebrow,
              richText: true,
              children: eyebrow
            }), /*#__PURE__*/_jsx(Text, {
              typog: "headline6",
              className: styles.headline,
              textElement: "span",
              richText: true,
              children: headline
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.info,
          children: [showSubheadingPrice && /*#__PURE__*/_jsx(Text, {
            richText: true,
            textElement: "div",
            className: classnames({
              [styles.subheadPrice]: true,
              [styles.subheadPriceNoSubhead]: !subhead
            }),
            typog: subheadTypog,
            children: subheadingPrice
          }), subhead && /*#__PURE__*/_jsx(Text, {
            typog: subheadTypog,
            className: styles.subhead,
            richText: true,
            children: subhead
          }), (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.text) && /*#__PURE__*/_jsx(Text, {
            typog: "bodycopy",
            className: classnames(styles.error, {
              [styles.errorRed]: errorMessage.red
            }),
            children: errorMessage.text
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.ctaGroup,
            children: [(cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url) && /*#__PURE__*/_jsx("div", {
              className: styles.priceWrapper,
              children: renderButton(cta)
            }), hasCtaTwo && /*#__PURE__*/_jsx("div", {
              className: styles.ctaTwoWrapper,
              children: renderButton(ctaTwo, true)
            }), ctaTwoPopup && /*#__PURE__*/_jsx("div", {
              className: styles.ctaTwoWrapper,
              children: /*#__PURE__*/_jsx(Popup, {
                popupCloseClass: styles.popupClose,
                contentClass: styles.popupContent,
                clickOutsideDeactivates: false,
                handle: renderPopupButton(ctaTwo),
                ref: popupRef,
                children: /*#__PURE__*/_jsx(PopupContentBlock, _objectSpread({}, popupContent))
              })
            })]
          }), footnote && /*#__PURE__*/_jsx(Text, {
            className: styles.footnote,
            typog: "bodycopySmall",
            richText: true,
            children: footnote
          }), pricing && /*#__PURE__*/_jsx("div", {
            className: styles.pricingFormWrapper,
            children: /*#__PURE__*/_jsx(PricingForm, {
              pricing: _objectSpread(_objectSpread({}, pricing), {}, {
                input: pricing.input ? _objectSpread(_objectSpread({}, pricing.input), {}, {
                  arrowButton: true,
                  small: true,
                  autoFocus: autoFocus,
                  className: styles.pricingForm
                }) : undefined
              }),
              isOpen: showPricingForm,
              onZipClick: onZipClick,
              zipClassName: styles.zipTextPrice,
              zipTypog: "bodycopySmall"
            })
          })]
        })]
      })
    })]
  });
};